import { ActionType } from './simple-action';
import { StandardAction } from './standard-action';

export class DialogMobileAction extends StandardAction {
  public actionType: ActionType;

  constructor(name: string, icon: string, text: string, type: ActionType) {
    super(name, icon, text);
    this.actionType = type;
  }
}
